/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable default-case, react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Card, Form, Select, Row, Col, Typography, Button, Spin, message, Divider, Alert } from 'antd';
import { BankOutlined, DollarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { financialAccountsAPI, erpAccountMappingsAPI } from '../../../services/api';

const { Title, Text } = Typography;
const { Option } = Select;

// Step 3: Financial Accounts
// - Loads financial accounts per organisation and per type
// - Auto-fills first available options if user didn't select
// - Optional (currently disabled) auto-fill from ERP default mappings
// - Computes a suggested, balanced ERP journal entry for preview/PDF
const Step3FinancialAccounts = ({ data, onDataChange }) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [senderAccounts, setSenderAccounts] = useState([]);
  const [beneficiaryAccounts, setBeneficiaryAccounts] = useState([]);
  const [senderAssetAccounts, setSenderAssetAccounts] = useState([]);
  const [beneficiaryAssetAccounts, setBeneficiaryAssetAccounts] = useState([]);
  const [senderLiabilityAccounts, setSenderLiabilityAccounts] = useState([]);
  const [senderIncomeAccounts, setSenderIncomeAccounts] = useState([]);
  const [beneficiaryIncomeAccounts, setBeneficiaryIncomeAccounts] = useState([]);
  const [beneficiaryExpenseAccounts, setBeneficiaryExpenseAccounts] = useState([]);
  const [assetAccounts, setAssetAccounts] = useState([]);
  const [liabilityAccounts, setLiabilityAccounts] = useState([]);
  const [incomeAccounts, setIncomeAccounts] = useState([]);
  const [expenseAccounts, setExpenseAccounts] = useState([]);

  useEffect(() => {
    if (data.sender_id && data.beneficiary_id) {
      loadFinancialAccounts();
    }
  }, [data.sender_id, data.beneficiary_id]);

  const loadFinancialAccounts = async () => {
    try {
      setLoading(true);
      
      const [
        senderAssetAccountsRes,
        senderLiabilityAccountsRes,
        senderIncomeAccountsRes,
        beneficiaryAssetAccountsRes,
        beneficiaryIncomeAccountsRes,
        beneficiaryExpenseAccountsRes,
        beneficiaryAssetAccountsForVATRes
      ] = await Promise.all([
        financialAccountsAPI.getByTypeAndOrg(1, data.sender_id), // Sender Asset accounts
        financialAccountsAPI.getByTypeAndOrg(2, data.sender_id), // Sender Liability accounts
        financialAccountsAPI.getByTypeAndOrg(3, data.sender_id), // Sender Income accounts
        financialAccountsAPI.getByTypeAndOrg(1, data.beneficiary_id), // Beneficiary Asset accounts
        financialAccountsAPI.getByTypeAndOrg(3, data.beneficiary_id), // Beneficiary Income accounts
        financialAccountsAPI.getByTypeAndOrg(4, data.beneficiary_id), // Beneficiary Expense accounts
        financialAccountsAPI.getByTypeAndOrg(1, data.beneficiary_id) // Beneficiary Asset accounts for VAT
      ]);

      // console.debug('Full API Responses:', {
      //   senderAssetAccountsRes,
      //   senderLiabilityAccountsRes,
      //   senderIncomeAccountsRes,
      //   beneficiaryAssetAccountsRes,
      //   beneficiaryIncomeAccountsRes,
      //   beneficiaryExpenseAccountsRes,
      //   beneficiaryAssetAccountsForVATRes
      // });
      
      // Sender organization accounts by type
      const senderAssetAccounts = senderAssetAccountsRes.data?.data?.financialAccounts || 
                                 senderAssetAccountsRes.data?.financialAccounts || 
                                 senderAssetAccountsRes.data || [];
      
      const senderLiabilityAccounts = senderLiabilityAccountsRes.data?.data?.financialAccounts || 
                                     senderLiabilityAccountsRes.data?.financialAccounts || 
                                     senderLiabilityAccountsRes.data || [];
      
      const senderIncomeAccounts = senderIncomeAccountsRes.data?.data?.financialAccounts || 
                                  senderIncomeAccountsRes.data?.financialAccounts || 
                                  senderIncomeAccountsRes.data || [];
      
      // Beneficiary organization accounts by type
      const beneficiaryAssetAccounts = beneficiaryAssetAccountsRes.data?.data?.financialAccounts || 
                                      beneficiaryAssetAccountsRes.data?.financialAccounts || 
                                      beneficiaryAssetAccountsRes.data || [];
      
      const beneficiaryIncomeAccounts = beneficiaryIncomeAccountsRes.data?.data?.financialAccounts || 
                                       beneficiaryIncomeAccountsRes.data?.financialAccounts || 
                                       beneficiaryIncomeAccountsRes.data || [];
      
      const beneficiaryExpenseAccounts = beneficiaryExpenseAccountsRes.data?.data?.financialAccounts || 
                                        beneficiaryExpenseAccountsRes.data?.financialAccounts || 
                                        beneficiaryExpenseAccountsRes.data || [];
      
      // Beneficiary Asset accounts for VAT
      const assetAccounts = beneficiaryAssetAccountsForVATRes.data?.data?.financialAccounts || 
                           beneficiaryAssetAccountsForVATRes.data?.financialAccounts || 
                           beneficiaryAssetAccountsForVATRes.data || [];
      
      // For backward compatibility, keep these arrays
      const liabilityAccounts = senderLiabilityAccounts;
      const incomeAccounts = senderIncomeAccounts;
      const expenseAccounts = beneficiaryExpenseAccounts;

      setSenderAccounts(senderAccounts);
      setBeneficiaryAccounts(beneficiaryAccounts);
      setSenderAssetAccounts(senderAssetAccounts);
      setBeneficiaryAssetAccounts(beneficiaryAssetAccounts);
      setSenderLiabilityAccounts(senderLiabilityAccounts);
      setSenderIncomeAccounts(senderIncomeAccounts);
      setBeneficiaryIncomeAccounts(beneficiaryIncomeAccounts);
      setBeneficiaryExpenseAccounts(beneficiaryExpenseAccounts);
      setAssetAccounts(assetAccounts);
      setLiabilityAccounts(liabilityAccounts);
      setIncomeAccounts(incomeAccounts);
      setExpenseAccounts(expenseAccounts);

      // console.debug('Extracted accounts:', {
      //   senderAccounts,
      //   beneficiaryAccounts,
      //   assetAccounts,
      //   liabilityAccounts,
      //   incomeAccounts,
      //   expenseAccounts
      // });

      // Auto-select first available accounts if not already selected
      const autoSelections = {};
      
      // Sender Asset accounts (for Unsettled Dues and Bank Account dropdowns)
      if (!data.sender_debit_account_id && senderAssetAccounts.length > 0) {
        autoSelections.sender_debit_account_id = senderAssetAccounts[0].id;
      }
      if (!data.sender_credit_account_id && senderAssetAccounts.length > 1) {
        autoSelections.sender_credit_account_id = senderAssetAccounts[1].id;
      } else if (!data.sender_credit_account_id && senderAssetAccounts.length > 0) {
        autoSelections.sender_credit_account_id = senderAssetAccounts[0].id;
      }
      
      // Sender Income accounts
      if (!data.sender_income_account_id && senderIncomeAccounts.length > 0) {
        autoSelections.sender_income_account_id = senderIncomeAccounts[0].id;
      }
      
      // Sender Liability accounts
      if (!data.sender_tax_liability_account_id && senderLiabilityAccounts.length > 0) {
        autoSelections.sender_tax_liability_account_id = senderLiabilityAccounts[0].id;
      }
      
      // Beneficiary Asset accounts (for Debit Account dropdown)
      if (!data.beneficiary_debit_account_id && beneficiaryAssetAccounts.length > 0) {
        autoSelections.beneficiary_debit_account_id = beneficiaryAssetAccounts[0].id;
      }
      
      // Beneficiary Income accounts (for Credit Account dropdown)
      if (!data.beneficiary_credit_account_id && beneficiaryIncomeAccounts.length > 0) {
        autoSelections.beneficiary_credit_account_id = beneficiaryIncomeAccounts[0].id;
      }
      
      // Beneficiary Expense accounts
      if (!data.beneficiary_expense_account_id && beneficiaryExpenseAccounts.length > 0) {
        autoSelections.beneficiary_expense_account_id = beneficiaryExpenseAccounts[0].id;
      }
      
      // Beneficiary Asset accounts for VAT
      if (!data.beneficiary_tax_asset_account_id && assetAccounts.length > 0) {
        autoSelections.beneficiary_tax_asset_account_id = assetAccounts[0].id;
      }

      // Update form and data with auto-selections
      if (Object.keys(autoSelections).length > 0) {
        form.setFieldsValue(autoSelections);
        onDataChange(autoSelections);
      }

      // Check if we have any accounts at all
      const totalAccounts = senderAccounts.length + beneficiaryAccounts.length + 
                           assetAccounts.length + liabilityAccounts.length + 
                           incomeAccounts.length + expenseAccounts.length;
      
      // console.debug('Total accounts found:', totalAccounts);
      // console.debug('Settlement data:', { sender_id: data.sender_id, beneficiary_id: data.beneficiary_id });
      
      if (totalAccounts === 0) {
        message.warning('No financial accounts found. Please create some financial accounts first.');
      }

    } catch (error) {
      message.error('Failed to load financial accounts: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleAutoFillDefaults = async () => {
    try {
      setLoading(true);
      
      // Get default ERP mappings for sender and beneficiary
      const [senderMappings, beneficiaryMappings] = await Promise.all([
        erpAccountMappingsAPI.getByOrganisation(data.sender_id),
        erpAccountMappingsAPI.getByOrganisation(data.beneficiary_id)
      ]);

      const senderDefaults = senderMappings.data?.filter(m => m.is_default) || [];
      const beneficiaryDefaults = beneficiaryMappings.data?.filter(m => m.is_default) || [];

      // Map defaults to form fields
      const defaultValues = {};
      
      senderDefaults.forEach(mapping => {
        switch (mapping.financial_account_type_id) {
          case 1: // Asset
            if (mapping.erp_account_name?.includes('Receivable')) {
              defaultValues.sender_debit_account_id = mapping.id;
            } else if (mapping.erp_account_name?.includes('Bank')) {
              defaultValues.sender_credit_account_id = mapping.id;
            }
            break;
          case 2: // Liability
            defaultValues.sender_tax_liability_account_id = mapping.id;
            break;
          case 3: // Income
            defaultValues.sender_income_account_id = mapping.id;
            break;
        }
      });

      beneficiaryDefaults.forEach(mapping => {
        switch (mapping.financial_account_type_id) {
          case 1: // Asset
            if (mapping.erp_account_name?.includes('Bank')) {
              defaultValues.beneficiary_debit_account_id = mapping.id;
            } else if (mapping.erp_account_name?.includes('VAT')) {
              defaultValues.beneficiary_tax_asset_account_id = mapping.id;
            }
            break;
          case 3: // Income
            defaultValues.beneficiary_credit_account_id = mapping.id;
            break;
          case 4: // Expense
            defaultValues.beneficiary_expense_account_id = mapping.id;
            break;
        }
      });

      form.setFieldsValue(defaultValues);
      onDataChange(defaultValues);
      message.success('Default ERP mappings applied successfully');

    } catch (error) {
      message.error(intl.formatMessage({ id: 'settlement_FailedToLoadAccounts' }));
    } finally {
      setLoading(false);
    }
  };
  const handleFormChange = (changedFields, allFields) => {
    const formData = form.getFieldsValue();
    onDataChange(formData);
  };

  const getAccountById = (accountId, accountsList) => {
    return accountsList.find(acc => acc.id === accountId);
  };

  const calculateJournalEntry = () => {
    if (!data.amount || !data.fees_amount || !data.tax_amount) return null;

    const senderDebitAccount = getAccountById(data.sender_debit_account_id, senderAccounts);
    const senderCreditAccount = getAccountById(data.sender_credit_account_id, senderAccounts);
    const senderIncomeAccount = getAccountById(data.sender_income_account_id, incomeAccounts);
    const senderTaxAccount = getAccountById(data.sender_tax_liability_account_id, liabilityAccounts);

    if (!senderDebitAccount || !senderCreditAccount || !senderIncomeAccount || !senderTaxAccount) {
      return null;
    }

    const totalAmount = Math.abs(data.amount) + data.fees_amount + data.tax_amount;

    return {
      entries: [
        {
          account: senderDebitAccount.name,
          type: 'Asset',
          debit: totalAmount,
          credit: 0,
          field: 'sender_debit_account_id'
        },
        {
          account: senderCreditAccount.name,
          type: 'Asset',
          debit: 0,
          credit: Math.abs(data.amount),
          field: 'sender_credit_account_id'
        },
        {
          account: senderTaxAccount.name,
          type: 'Liability',
          debit: 0,
          credit: data.tax_amount,
          field: 'sender_tax_liability_account_id'
        },
        {
          account: senderIncomeAccount.name,
          type: 'Income',
          debit: 0,
          credit: data.fees_amount,
          field: 'sender_income_account_id'
        }
      ],
      totalDebit: totalAmount,
      totalCredit: Math.abs(data.amount) + data.tax_amount + data.fees_amount,
      isBalanced: true
    };
  };

  const journalEntry = calculateJournalEntry();

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px' }}>{intl.formatMessage({ id: 'settlement_LoadingFinancialAccounts' })}</div>
      </div>
    );
  }

  return (
    <div className="step3-financial-accounts">
      <Card>
        <Title level={4}>
          <BankOutlined /> {intl.formatMessage({ id: 'settlement_MapFinancialAccountsForERP' })}
        </Title>

        <Alert
          message={intl.formatMessage({ id: 'settlement_ERPJournalSuggestionsOnly' })}
          description={intl.formatMessage({ id: 'settlement_ERPJournalSuggestionsDescription' })}
          type="info"
          showIcon
          style={{ marginBottom: '24px' }}
        />

        {/** Controls moved to bottom */}

        <Form
          form={form}
          layout="vertical"
          onValuesChange={handleFormChange}
          initialValues={{
            sender_debit_account_id: data.sender_debit_account_id,
            sender_credit_account_id: data.sender_credit_account_id,
            sender_income_account_id: data.sender_income_account_id,
            sender_tax_liability_account_id: data.sender_tax_liability_account_id,
            beneficiary_debit_account_id: data.beneficiary_debit_account_id,
            beneficiary_credit_account_id: data.beneficiary_credit_account_id,
            beneficiary_expense_account_id: data.beneficiary_expense_account_id,
            beneficiary_tax_asset_account_id: data.beneficiary_tax_asset_account_id
          }}
        >
          <Title level={5}>{intl.formatMessage({ id: 'settlement_SenderAccountsMwaslaTech' })}</Title>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="sender_debit_account_id"
                label={intl.formatMessage({ id: 'settlement_UnsettledDuesAccountAsset' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectUnsettledDuesAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_PTOReceivableMidar' })}
              >
                <Select
                  placeholder="Select unsettled dues account"
                  showSearch
                  optionFilterProp="children"
                >
                  {senderAssetAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="sender_credit_account_id"
                label={intl.formatMessage({ id: 'settlement_BankAccountAsset' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectBankAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_BankAccountNBE' })}
              >
                <Select
                  placeholder="Select bank account"
                  showSearch
                  optionFilterProp="children"
                >
                  {senderAssetAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="sender_income_account_id"
                label={intl.formatMessage({ id: 'settlement_IncomeAccount' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectIncomeAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_CommissionIncome' })}
              >
                <Select
                  placeholder="Select income account"
                  showSearch
                  optionFilterProp="children"
                >
                  {senderIncomeAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="sender_tax_liability_account_id"
                label={intl.formatMessage({ id: 'settlement_VATLiabilityAccount' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectTaxLiabilityAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_VATPayable' })}
              >
                <Select
                  placeholder="Select VAT liability account"
                  showSearch
                  optionFilterProp="children"
                >
                  {senderLiabilityAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Title level={5}>{intl.formatMessage({ id: 'settlement_BeneficiaryAccountsSuggestedForERP' })}</Title>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="beneficiary_debit_account_id"
                label={intl.formatMessage({ id: 'settlement_DebitAccountAsset' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectDebitAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_OperatingAccount' })}
              >
                <Select
                  placeholder="Select debit account"
                  showSearch
                  optionFilterProp="children"
                >
                  {beneficiaryAssetAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="beneficiary_credit_account_id"
                label={intl.formatMessage({ id: 'settlement_CreditAccountIncome' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectCreditAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_FareRevenue' })}
              >
                <Select
                  placeholder="Select credit account"
                  showSearch
                  optionFilterProp="children"
                >
                  {beneficiaryIncomeAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="beneficiary_expense_account_id"
                label={intl.formatMessage({ id: 'settlement_ExpenseAccount' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectExpenseAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_CommissionExpense' })}
              >
                <Select
                  placeholder="Select expense account"
                  showSearch
                  optionFilterProp="children"
                >
                  {beneficiaryExpenseAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="beneficiary_tax_asset_account_id"
                label={intl.formatMessage({ id: 'settlement_VATAssetAccount' })}
                rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectTaxAssetAccount' }) }]}
                help={intl.formatMessage({ id: 'settlement_VATReceivable' })}
              >
                <Select
                  placeholder="Select VAT asset account"
                  showSearch
                  optionFilterProp="children"
                >
                  {assetAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name} - {account.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {/* Bottom controls: Auto-Fill and Reset (disabled as feature is paused) */}
        <div style={{ marginTop: '12px', marginBottom: '16px', textAlign: 'right' }}>
          <Button 
            type="dashed" 
            onClick={handleAutoFillDefaults}
            loading={loading}
            icon={<InfoCircleOutlined />}
            disabled
          >
            {intl.formatMessage({ id: 'settlement_AutoFillFromDefaultERPMappings' })}
          </Button>
          <Button 
            style={{ marginLeft: '8px' }} 
            onClick={() => {
              form.resetFields();
              onDataChange({
                sender_debit_account_id: null,
                sender_credit_account_id: null,
                sender_income_account_id: null,
                sender_tax_liability_account_id: null,
                beneficiary_debit_account_id: null,
                beneficiary_credit_account_id: null,
                beneficiary_expense_account_id: null,
                beneficiary_tax_asset_account_id: null
              });
            }}
            disabled
          >
            {intl.formatMessage({ id: 'settlement_Reset' })}
          </Button>
        </div>

        {journalEntry && (
          <>
            <Divider />
            <Title level={5}>{intl.formatMessage({ id: 'settlement_SuggestedJournalEntryForERP' })}</Title>
            <Alert
              message={intl.formatMessage({ id: 'settlement_ERPJournalSuggestionBalanced' })}
              description={intl.formatMessage({ id: 'settlement_ERPJournalSuggestionDescription' })}
              type="success"
              showIcon
              style={{ marginBottom: '16px' }}
            />
            
            <div style={{ 
              border: '1px solid #d9d9d9', 
              borderRadius: '6px', 
              padding: '16px', 
              backgroundColor: '#fafafa',
              marginBottom: '16px'
            }}>
              <Row gutter={[16, 8]} style={{ fontWeight: 'bold', borderBottom: '2px solid #d9d9d9', paddingBottom: '8px', marginBottom: '12px' }}>
                <Col span={10}>Account</Col>
                <Col span={4} style={{ textAlign: 'right' }}>Debit</Col>
                <Col span={4} style={{ textAlign: 'right' }}>Credit</Col>
                <Col span={6}>Field Reference</Col>
              </Row>
              
              {journalEntry.entries.map((entry, index) => (
                <Row key={index} gutter={[16, 8]} style={{ marginBottom: '8px' }}>
                  <Col span={10}>
                    <Text strong>{entry.account}</Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: '12px' }}>({entry.type})</Text>
                  </Col>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    {entry.debit > 0 ? `${entry.debit} EGP` : ''}
                  </Col>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    {entry.credit > 0 ? `${entry.credit} EGP` : ''}
                  </Col>
                  <Col span={6}>
                    <Text code style={{ fontSize: '11px' }}>{entry.field}</Text>
                  </Col>
                </Row>
              ))}
              
              <Row gutter={[16, 8]} style={{ 
                fontWeight: 'bold', 
                borderTop: '2px solid #d9d9d9', 
                paddingTop: '8px', 
                marginTop: '12px',
                backgroundColor: '#f0f0f0',
                padding: '8px',
                borderRadius: '4px'
              }}>
                <Col span={10}>Total</Col>
                <Col span={4} style={{ textAlign: 'right' }}>
                  {journalEntry.totalDebit} EGP
                </Col>
                <Col span={4} style={{ textAlign: 'right' }}>
                  {journalEntry.totalCredit} EGP
                </Col>
                <Col span={6}>
                  {journalEntry.isBalanced ? '✅ Balanced' : '❌ Unbalanced'}
                </Col>
              </Row>
            </div>
            
            <Alert
              message="Journal Entry Explanation"
              description={
                <div>
                  <p><strong>Unsettled Dues ({journalEntry.totalDebit} EGP):</strong> This liability was created when MwaslaTech collected money via the app</p>
                  <p><strong>Bank Account ({Math.abs(data.amount)} EGP):</strong> Net cash transferred to beneficiary</p>
                  <p><strong>VAT Payable ({data.tax_amount} EGP):</strong> VAT on fees</p>
                  <p><strong>Commission Income ({data.fees_amount} EGP):</strong> Total fees earned</p>
                  <p>This entry clears the unsettled dues and recognizes income and tax.</p>
                </div>
              }
              type="info"
              showIcon
              style={{ marginBottom: '24px' }}
            />
          </>
        )}
      </Card>
    </div>
  );
};

export default Step3FinancialAccounts;
